export enum ConsoleColor {
    RESET = "\u001b[0m",
    RED = "\u001b[31m",
    YELLOW = "\u001b[33m",
    GREEN = "\u001b[32m"
}

export enum EnvType {
    Boolean = "BOOLEAN",
    String = "STRING",
    Number = "NUMBER"
}